import React from 'react';
import CourseGuide from "../CourseGuide/CourseGuide";
import Scorecard from "../Scorecard/Scorecard";
import { useTranslation } from "react-i18next";
import UnitToggle from "../UnitToggle/UnitToggle";
import SelectButton from "../SelectButton/SelectButton";
import MenuItem from "@mui/material/MenuItem";

const CourseSection = React.memo(({ 
  selectedGuide, 
  selectedHole, 
  setSelectedHole,
  setSelectedGuide, 
  unit,
  onUnitToggle,
  clubData
}) => {
  const { t } = useTranslation();

  return (
    <div className="SC-CG">
      <div className="topBar">
        <h1>{t("course_guide_header")}</h1>
        <div className="topBar-controls">
          <UnitToggle unit={unit} onToggle={onUnitToggle} />
          <SelectButton
            selectedItem={selectedGuide}
            setSelectedItem={setSelectedGuide}
            buttonText={selectedGuide.title}
          >
            {(handleItemClick) => (
              <div>
                {clubData.guides.map((item) => (
                  <MenuItem
                    key={item.title}
                    onClick={(event) => handleItemClick(event, item)}
                  >
                    {item.title}
                  </MenuItem>
                ))}
              </div>
            )}
          </SelectButton>
        </div>
      </div>

      <div className="CourseGuide">
        <CourseGuide
          clubData={selectedGuide}
          setSelectedHole={setSelectedHole}
          selectedHole={selectedHole}
        />
      </div>

      <div className="Scorecard">
        <Scorecard
          clubData={selectedGuide}
          selectedHole={selectedHole}
          setSelectedHole={setSelectedHole}
          courseTitle={selectedGuide.title}
          unit={unit}
        />
      </div>
    </div>
  );
});

CourseSection.displayName = 'CourseSection';

export default CourseSection; 